
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host{
  display:inline-block;
}

.phone-contact{
  position:relative;
  display:flex;
  align-items:center;
  font-family:var(--ff-display);
  font-weight:var(--fw-bold);
  color:var(--primary-blue);
  text-decoration-line:none;
}

.phone-contact.normal{
  font-size:var(--fs-sm);
  line-height:var(--lh-sm);
}

.phone-contact.small{
  font-size:var(--fs-xs);
  line-height:var(--lh-xs);
}

.phone-contact:hover{
  color:var(--primary-blue-light-2);
}

ghs-icon{
  margin-right:0.25rem;
}

.phone-contact.header{
  color:var(--neutral-white);
}

.phone-contact.header:hover{
  color:var(--neutral-gray-4);
}
`;